import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {UsuarioAsignado} from "../../interfaces/asignacion-interface";
import {TableModule} from "primeng/table";
import {TagModule} from "primeng/tag";
import {Button} from "primeng/button";
import {ConfirmationService, MessageService} from "primeng/api";
import {ConfirmPopupModule} from "primeng/confirmpopup";
import {ToastModule} from "primeng/toast";
import {NgForOf, NgIf, NgTemplateOutlet} from "@angular/common";
import {KnopComponent} from "../../../../shared/components/knop/knop.component";

@Component({
    selector: 'app-assigned-users',
    standalone: true,
    imports: [
        TableModule,
        TagModule,
        Button,
        ConfirmPopupModule,
        ToastModule,
        NgTemplateOutlet,
        NgIf,
        KnopComponent,
        NgForOf
    ],
    templateUrl: './assigned-users.component.html',
    styleUrl: './assigned-users.component.scss',
    providers: [ConfirmationService, MessageService]
})
export class AssignedUsersComponent implements OnInit {
    constructor() {
    }
    ngOnInit(): void {
        console.log(`ngOnInit() ->` + this.constructor.name)
    }
    @Input() assignedUsers: UsuarioAsignado[] = [];
    @Input() confirmarCancelTemplate!: TemplateRef<any | null>;
    @Input() progresoEvalTemplate!: TemplateRef<any | null>;
    @Output() itemClicked = new EventEmitter<{ user: any, event: Event }>();
    /**
     * Específica sí se activan o no los botones de acción del componente.
     */
    @Input() renderActions: boolean = true;
    @Input() renderKnobActions: boolean = false;
    onItemClicked(user: UsuarioAsignado, event: Event) {
        this.itemClicked.emit({user, event});
    }
}
